import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmp48nj1ri7/layouts/custom.vue").then(m => m.default || m))
}